import CheckboxIndicator from "./checkbox-indicator";

export default CheckboxIndicator;
